<p>list-hours-field works!</p>
